import React, { useState } from "react";
import { useBarometer } from "./data/access/use-barometer";
import Banner from "./ui/banner";
import Block from "./ui/block";
import { AnimationContainer } from "./ui/components/animation-container";

interface Props {
  articleId: string;
}

function EvidenceBarometer(props: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const { barometer, isLoading } = useBarometer({ uuid: props.articleId });

  if (!barometer || isLoading) return null;

  return (
    <>
      <AnimationContainer.Banner visible={isOpen}>
        <Banner onClick={() => setIsOpen(true)} barometer={barometer} />
      </AnimationContainer.Banner>

      <AnimationContainer.Block visible={isOpen}>
        <Block onClose={() => setIsOpen(false)} barometer={barometer} />
      </AnimationContainer.Block>
    </>
  );
}

export default EvidenceBarometer;
